import { PriceDetailMapper } from './PriceDetailMapper.js';
import { PriceProductsMapper } from './PriceProductsMapper.js';

/**
 * Plain object Packlink's API response representation.
 *
 */

class PriceMapper {
  static createModelFromResponse(response) {
    return {
      price: PriceDetailMapper.createModelFromResponse(response.price),
      products: PriceProductsMapper.createModelFromResponse(response.products),
      availableProducts: PriceProductsMapper.createModelFromResponse(response.available_products),
      packlinkReference: response.packlink_reference || undefined
    };
  }
}

export { PriceMapper };
//# sourceMappingURL=PriceMapper.js.map
